export default "__VITE_ASSET__DSSX1TDK__"